<template>
  <div>
    <button
      class="btn-link"
      @click="modalVisibility = true"
    >
      {{ I18n.t("edit") }}
      <span class="icon-pencil ml-1 mr-3" />
    </button>
    <Modal
      v-if="modalVisibility"
      @close-modal="closeModal"
      :bid="auction.lastOrder"
    >
      <template slot="header">
        <div class="my-3 px-3">
          {{ I18n.t("employees.auctions_catalogs.modal.set_limit") }}
          <input
            v-model="limitValue"
            type="number"
          >
        </div>
      </template>
      <template slot="approveBtn">
        <button
          type="button"
          class="btn btn-secondary mr-3"
          @click="editLastOrder"
        >
          {{ I18n.t("simple_form.submit") }}
        </button>
      </template>
      <template slot="disapproveBtn">
        <button
          type="button"
          class="btn btn-secondary"
          @click="closeModal"
        >
          {{ I18n.t("simple_form.cancel") }}
        </button>
      </template>
    </Modal>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import Modal from '@/employees_orders_panel/components/modal';

  export default {
    name: 'EditLastOrder',
    components: {
      Modal,
    },
    props: {
      auction: {
        type: Object,
      },
    },
    data() {
      return {
        modalVisibility: false,
        limitValue: 0,
      };
    },
    methods: {
      ...mapActions(['updateLastOrder']),
      editLastOrder() {
        this.updateLastOrder({
          internetAuctionId: this.auction.id,
          orderId: this.auction.lastOrder.id,
          value: this.limitValue,
        });
        this.closeModal();
      },
      closeModal() {
        this.modalVisibility = false;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees_orders_panel/components/orders/last_order/edit.vue?d76566b4